import React from "react";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "SWIA cut my commercial premiums by 22% and upgraded the coverage. The whole thing took a week. That's not insurance — that's a miracle.",
    name: "Daniela R.",
    role: "Studio Owner, Los Angeles",
    avatar:
      "https://images.unsplash.com/photo-1759350075177-eeb89d507990?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwYmxhY2slMjBhbmQlMjB3aGl0ZXxlbnwwfHx8fDE3NzcwMDU5MTh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "A real human, a real plan, and a real follow-through on a tricky claim. I moved my auto, home, and umbrella over in one afternoon.",
    name: "Marcus T.",
    role: "Founder, Bay Area",
    avatar:
      "https://images.unsplash.com/photo-1769628027250-d2a7a5a4eb64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwYmxhY2slMjBhbmQlMjB3aGl0ZXxlbnwwfHx8fDE3NzcwMDU5MTh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "They treated my life policy like an estate plan, not a product. My advisor felt like a partner, not a salesperson.",
    name: "Priya S.",
    role: "Physician, San Diego",
    avatar:
      "https://images.unsplash.com/photo-1765366574945-e2f1b4b1a5b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwYmxhY2slMjBhbmQlMjB3aGl0ZXxlbnwwfHx8fDE3NzcwMDU5MTh8MA&ixlib=rb-4.1.0&q=85",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="section-testimonials"
      className="bg-[#fafafa] border-t border-neutral-200"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-24 md:py-36">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14" data-reveal>
          <div>
            <div className="text-xs uppercase tracking-[0.22em] text-neutral-500 mb-6">
              In their words
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] text-black leading-[1.02]">
              Clients who
              <br />
              <span className="italic font-medium">stay clients.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-reveal-group>
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-card-${i + 1}`}
              data-reveal-child
              data-reveal-delay={i + 1}
              className="card-lift bg-white border border-neutral-200 rounded-2xl p-8 flex flex-col gap-6"
            >
              <div className="flex items-center gap-1 text-black">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} size={14} fill="#0a0a0a" stroke="#0a0a0a" />
                ))}
              </div>
              <blockquote className="font-display text-lg md:text-xl text-black leading-snug tracking-[-0.01em]">
                “{t.quote}”
              </blockquote>
              <figcaption className="flex items-center gap-3 mt-auto pt-4 border-t border-neutral-200">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover bw"
                  loading="lazy"
                />
                <div>
                  <div className="text-sm font-medium text-black">{t.name}</div>
                  <div className="text-xs text-neutral-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
